import AppLogo from '../AppLogo';
import Menu from '../Menu';

import useStyles from './styles';

function EditorSidebar() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <AppLogo />
      </div>
      <Menu />
    </div>
  );
}
export default EditorSidebar;
